import { universalTypeFilterId } from '../../constants/filters';
import { ProductKeys } from '../../constants/product-keys';

// The universal Type filter represents Atlas or web-crawler app selection instead of a control
// the user can see, so a selection there must not count towards any selected-filter total.
export const isFilterSelectionCountable = (
	filterId: string,
	selectedProducts: string[],
): boolean => {
	if (filterId !== universalTypeFilterId) {
		return true;
	}

	return (
		!selectedProducts.includes(ProductKeys.Atlas) &&
		!selectedProducts.includes(ProductKeys.AtlassianWebCrawler)
	);
};
